/**
 * Import libraries
 */
import BootstrapVue from 'bootstrap-vue';
import Loading from 'vue-loading-overlay';
import MilestonesPlugin from "./plugins/milestones";
import Vue from './vue';
import VueHelpers from "./plugins/vue-helpers";
import WsUiKitLibrary from '@milestoneslabs/milestones-ui-kit/src';
import router from './landing-page-router';
import App from './landingPageEntry';
import './providers/validate';


/**
 * Initialize Components
 */
import store from './store';
import VueLazyload from "vue-lazyload";
import {Engine} from "@milestoneslabs/milestones-core-js";
import axios from "axios";
import {configureEngine, configureEvents, configureStore} from '@milestoneslabs/milestones-property-search';
import {priceFilter} from '@milestoneslabs/milestones-property-search/src/vue/filters/price.filter';
import {niceNumberFormatFilter} from '@milestoneslabs/milestones-property-search/src/vue/filters/niceNumberFormat.filter';
import {SearchCitiesConfig} from '@milestoneslabs/milestones-ui-kit/src/mixins/CityAndStateMixin';


// Ensure only one instance of Vue is created
require('./bootstrap');

Engine.config({
    xhrLib: axios,
    debug: true,
    apiVersion: 'v1',
    apiPrefix: 'public-api',
    defaultEnvironment: 'public',
    environments: {
        public: {
            apiHost: window.env.MILESTONES_AUTH_HOST,
            apiPrefix: window.env.MILESTONES_API_PREFIX,
            apiVersion: window.env.MILESTONES_API_VERSION,
        },
    },
});

configureEngine(Engine.rawConfig);
configureStore(store);
configureEvents({});
Vue.filter('price', priceFilter);
Vue.filter('niceNumberFormat', niceNumberFormatFilter);


/**
 * Plugins
 */
Vue.use(BootstrapVue);
Vue.use(WsUiKitLibrary);
Vue.use(MilestonesPlugin);
Vue.use(VueHelpers);
Vue.use(VueLazyload, {
    preLoad: 1.3,
    attempt: 1,
    lazyComponent: true,
});
Vue.use(Loading, {
    color: '#1ACEB3',
});

Vue.component('vue-loading', Loading);

Vue.directive('scroll-show', {
    inViewport(el) {
        var rect = el.getBoundingClientRect();
        return !(rect.bottom < 0 || rect.right < 0 ||
            rect.left > window.innerWidth ||
            rect.top > window.innerHeight);
    },
    bind(el, binding) {
        el.classList.add('before-enter');
        el.$onScroll = function () {
            if (binding.def.inViewport(el)) {
                el.classList.add('enter');
                el.classList.remove('before-enter');
                binding.def.unbind(el, binding);
            }
        };
        document.addEventListener('scroll', el.$onScroll);
    },
    inserted(el, binding) {
        el.$onScroll();
    },
    unbind(el, binding) {
        document.removeEventListener('scroll', el.$onScroll);
        delete el.$onScroll;
    },
});

const landingPageApp = new Vue({
    el: '#landing-page-app',
    router,
    store,
    render: (h) => h(App),
});

/**
 * Search Cities
 */
SearchCitiesConfig.set({
    xhrLib: axios,
    apiHost: window.env.MILESTONES_AUTH_HOST,
    apiVersion: window.env.MILESTONES_API_VERSION,
    apiPrefix: 'public-api',
});

